(function () {
  function initCookieConsent(cookie, cookieButtons) {
    function setButtonsBusy(isBusy) {
      cookieButtons.forEach(function (button) {
        button.disabled = isBusy;
        button.setAttribute("aria-busy", isBusy ? "true" : "false");
      });
    }
  
    function hideBanner() {
      cookie.classList.add("is-hidden");
      setButtonsBusy(false);
    }
  
    function showBanner() {
      cookie.classList.remove("is-hidden");
      setButtonsBusy(false);
    }
  
    function withCustomerPrivacy(callback) {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.setTrackingConsent === "function"
      ) {
        callback(window.Shopify.customerPrivacy);
        return;
      }
  
      if (
        !window.Shopify ||
        typeof window.Shopify.loadFeatures !== "function"
      ) {
        showBanner();
        return;
      }
  
      window.Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1",
          },
        ],
        function (error) {
          if (
            error ||
            !window.Shopify.customerPrivacy ||
            typeof window.Shopify.customerPrivacy.setTrackingConsent !== "function"
          ) {
            showBanner();
            return;
          }
  
          callback(window.Shopify.customerPrivacy);
        },
      );
    }
  
    function updateInitialBannerState(customerPrivacy) {
      if (
        typeof customerPrivacy.shouldShowBanner === "function" &&
        !customerPrivacy.shouldShowBanner()
      ) {
        hideBanner();
        return;
      }
  
      showBanner();
    }
  
    function saveConsentChoice(choice) {
      var accepted = choice === "accept";
  
      setButtonsBusy(true);
      withCustomerPrivacy(function (customerPrivacy) {
        var completed = false;
        var timeout = window.setTimeout(function () {
          if (!completed) {
            completed = true;
            showBanner();
          }
        }, 8000);
  
        try {
          customerPrivacy.setTrackingConsent(
            {
              analytics: accepted,
              marketing: accepted,
              preferences: accepted,
            },
            function (result) {
              if (completed) return;
  
              completed = true;
              window.clearTimeout(timeout);
  
              if (result && result.error) {
                showBanner();
                return;
              }
  
              hideBanner();
            },
          );
        } catch (error) {
          completed = true;
          window.clearTimeout(timeout);
          showBanner();
        }
      });
    }
  
    cookieButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        saveConsentChoice(
          button.getAttribute("data-hd-cookie-action") || "reject",
        );
      });
    });
  
    withCustomerPrivacy(updateInitialBannerState);
  }

  function init(root) {
    if (root.dataset.hdLovableReady === "true") return;
    root.dataset.hdLovableReady = "true";

    var nav = root.querySelector("[data-hd-nav]");
    var menuButton = root.querySelector("[data-hd-menu-button]");
    var mobileMenu = root.querySelector("[data-hd-mobile-menu]");
    var countEl = root.querySelector("[data-hd-count]");
    var cookie = root.querySelector("[data-hd-cookie]");
    var cookieButtons = root.querySelectorAll("[data-hd-cookie-action]");
    var lastY = window.scrollY;

    function onScroll() {
      if (!nav) return;
      var y = window.scrollY;
      nav.classList.toggle("is-scrolled", y > 50);
      if (y < 80) {
        nav.classList.remove("is-hidden");
      } else if (y > lastY + 4) {
        nav.classList.add("is-hidden");
        if (mobileMenu) mobileMenu.classList.remove("is-open");
      } else if (y < lastY - 4) {
        nav.classList.remove("is-hidden");
      }
      lastY = y;
    }

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    if (menuButton && mobileMenu) {
      menuButton.addEventListener("click", function () {
        mobileMenu.classList.toggle("is-open");
      });
    }

    if (countEl && "IntersectionObserver" in window) {
      var ran = false;
      var observer = new IntersectionObserver(function (entries) {
        if (ran || !entries.some(function (entry) { return entry.isIntersecting; })) return;
        ran = true;
        var start = null;
        var target = Number(countEl.getAttribute("data-hd-count") || "143");
        function frame(ts) {
          if (!start) start = ts;
          var pct = Math.min((ts - start) / 1800, 1);
          var eased = 1 - Math.pow(1 - pct, 3);
          countEl.textContent = String(Math.round(target * eased));
          if (pct < 1) window.requestAnimationFrame(frame);
        }
        window.requestAnimationFrame(frame);
        observer.disconnect();
      }, { threshold: 0.3 });
      observer.observe(countEl);
    }

    if (cookie) {
      initCookieConsent(cookie, cookieButtons);
    }

    initHowItWorks(root);
    initSafariAlphaVideos(root);
    initLanguageSwitcher(root);
    initCountrySwitcher(root);
    initVideo(root);
    initFocusGame(root);
    initEmailPopup(root);
    initQuiz(root);
    initFocusScoreQuiz(root);
    initProduct(root);
    initBlog(root);
    initCalculator(root);
    initEnterprise(root);
  }

  function initSafariAlphaVideos(root) {
    var ua = navigator.userAgent || "";
    var isSafari =
      document.documentElement.classList.contains("hd-is-safari") ||
      (/Safari/i.test(ua) && !/(Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android)/i.test(ua));
    if (!isSafari) return;
    document.documentElement.classList.add("hd-is-safari");

    root.querySelectorAll("[data-hd-safari-alpha-video]").forEach(function (media) {
      if (media.querySelector("[data-hd-safari-alpha-source]")) {
        media.classList.add("is-safari-alpha-native");
        return;
      }
      media.setAttribute("hidden", "hidden");
      media.classList.add("is-safari-hidden");
      var video = media.querySelector("video");
      if (!video) return;
      try {
        video.pause();
        video.removeAttribute("src");
        video.querySelectorAll("source").forEach(function (source) {
          source.removeAttribute("src");
        });
        video.load();
      } catch (error) {}
    });
  }

  function initLanguageSwitcher(root) {
    var langPrefix = /^(\/(?:en|de|fr|nl|it|sl))(\/|$)/;
    var marketPrefix = /^(\/(?:en|de|fr|nl|it|sl)-(?:si|eu))(\/|$)/;

    function returnToPath() {
      // return_to must be locale-prefix-free: Shopify re-prefixes it for the
      // newly selected language. Keeping the current prefix (e.g. /en-eu)
      // would redirect straight back to the old language.
      var path = window.location.pathname;
      path = path.replace(marketPrefix, function (_match, _prefix, slash) {
        return slash === "/" ? "/" : "";
      });
      path = path.replace(langPrefix, function (_match, _prefix, slash) {
        return slash === "/" ? "/" : "";
      });
      return (path || "/") + window.location.search + window.location.hash;
    }

    root.querySelectorAll(".hd-lang-form").forEach(function (form) {
      if (form.dataset.hdLangReady === "true") return;
      form.dataset.hdLangReady = "true";
      var option = form.querySelector("[data-hd-lang-option]");
      form.setAttribute("data-hd-lang-target", option ? option.getAttribute("data-hd-lang-target") || "en" : "en");
      form.addEventListener("submit", function (event) {
        var returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = returnToPath();
      });
      form.addEventListener("hd:update-return-to", function () {
        var returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = returnToPath();
      });
    });
  }

  function initCountrySwitcher(root) {
    var languagePrefixes = /^(\/(?:de|fr|nl|it|sl))(\/|$)/;
    var marketPrefixes = /^(\/(?:en|de|fr|nl|it|sl)-(?:si|eu))(\/|$)/;
    var storageKey = "humanodoro-country-selection";

    function stripPrefix(pathname) {
      var stripped = pathname.replace(languagePrefixes, function (_match, _prefix, slash) {
        return slash === "/" ? "/" : "";
      });
      stripped = stripped.replace(marketPrefixes, function (_match, _prefix, slash) {
        return slash === "/" ? "/" : "";
      });
      return stripped || "/";
    }

    function currentTheme() {
      return window.Shopify && window.Shopify.theme ? window.Shopify.theme : null;
    }

    function isPreviewTheme() {
      var theme = currentTheme();
      return Boolean(
        (window.Shopify && window.Shopify.previewMode) ||
          (theme && theme.role && theme.role !== "main" && theme.role !== "live")
      );
    }

    function previewParams(selection) {
      var params = new URLSearchParams(window.location.search);
      if (isPreviewTheme()) {
        var theme = currentTheme();
        params.set("_fd", params.get("_fd") || "0");
        params.set("pb", params.get("pb") || "0");
        if (theme && theme.id) params.set("preview_theme_id", theme.id);
      }
      if (selection && selection.code) {
        params.set("hd_country", selection.code);
      }
      return params.toString();
    }

    function returnPathForLocale(locale, selection) {
      var target = locale || "en";
      var pathname = stripPrefix(window.location.pathname);
      var localized = target === "en" ? pathname : "/" + target + (pathname === "/" ? "" : pathname);
      var query = previewParams(
        isPreviewTheme() && window.location.hostname === "checkout.humanodoro.com" && target !== "en" ? selection : null
      );
      return localized + (query ? "?" + query : "");
    }

    function targetOrigin(locale) {
      if (
        locale !== "en" &&
        isPreviewTheme() &&
        window.location.hostname === "checkout.humanodoro.com" &&
        window.Shopify &&
        window.Shopify.shop
      ) {
        return "https://" + window.Shopify.shop;
      }
      return window.location.origin;
    }

    function selectedCountryFromForm(form) {
      var option = form.querySelector("[data-hd-country-option]");
      var countryInput = form.querySelector('input[name="country_code"]');
      var localeInput = form.querySelector('input[name="locale_code"]');
      var flag = option ? option.querySelector(".hd-switcher-flag") : null;
      return {
        code: countryInput ? countryInput.value || "" : "",
        locale: localeInput ? localeInput.value || "en" : "en",
        flag: flag ? flag.textContent.trim() : "",
      };
    }

    function saveSelectedCountry(selection) {
      if (!selection.code) return;
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(selection));
      } catch (error) {}
    }

    function loadSelectedCountry() {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || "null");
      } catch (error) {
        return null;
      }
    }

    function applySelectedCountry(selection) {
      if (!selection || !selection.code) return;
      root.querySelectorAll(".hd-country-picker").forEach(function (picker) {
        var flag = picker.querySelector(".hd-country .hd-switcher-flag");
        var code = picker.querySelector(".hd-country__code");
        if (flag && selection.flag) flag.textContent = selection.flag;
        if (code) code.textContent = selection.code;
        picker.querySelectorAll(".hd-country-form").forEach(function (form) {
          var input = form.querySelector('input[name="country_code"]');
          var active = input && input.value === selection.code;
          var option = form.querySelector("[data-hd-country-option]");
          if (option) option.classList.toggle("is-active", Boolean(active));
        });
      });
    }

    function selectionFromQuery() {
      var params = new URLSearchParams(window.location.search);
      var code = params.get("hd_country");
      if (!code) return null;
      var selectedForm = null;
      root.querySelectorAll(".hd-country-form").forEach(function (form) {
        var input = form.querySelector('input[name="country_code"]');
        if (input && input.value === code) selectedForm = form;
      });
      return selectedForm ? selectedCountryFromForm(selectedForm) : null;
    }

    function cleanSelectionQuery() {
      var params = new URLSearchParams(window.location.search);
      if (!params.has("hd_country")) return;
      params.delete("hd_country");
      var query = params.toString();
      window.history.replaceState({}, "", window.location.pathname + (query ? "?" + query : "") + window.location.hash);
    }

    var querySelection = selectionFromQuery();
    if (querySelection) {
      saveSelectedCountry(querySelection);
      applySelectedCountry(querySelection);
      cleanSelectionQuery();
    } else {
      applySelectedCountry(loadSelectedCountry());
    }

    root.querySelectorAll(".hd-country-form").forEach(function (form) {
      if (form.dataset.hdCountryReady === "true") return;
      form.dataset.hdCountryReady = "true";
      var localizationAction = form.getAttribute("action") || "/localization";
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var selection = selectedCountryFromForm(form);
        saveSelectedCountry(selection);
        applySelectedCountry(selection);
        var targetPath = returnPathForLocale(selection.locale, selection);
        form.querySelectorAll('input[name="return_to"]').forEach(function (input) {
          input.value = targetPath;
        });
        window.setTimeout(function () {
          window.location.href = targetOrigin(selection.locale) + targetPath + window.location.hash;
        }, 0);
        if (window.fetch) {
          try {
            window.fetch(localizationAction, {
              method: "POST",
              body: new FormData(form),
              credentials: "same-origin",
              redirect: "manual",
            }).catch(function () {});
          } catch (error) {}
        }
      });
    });
  }

  function initHowItWorks(root) {
    var section = root.querySelector("[data-hd-hiw]");
    if (!section || section.dataset.hdHiwReady === "true") return;
    section.dataset.hdHiwReady = "true";

    var sticky = section.querySelector("[data-hd-hiw-sticky]");
    var canvas = section.querySelector("[data-hd-hiw-canvas]");
    var dots = section.querySelectorAll("[data-hd-hiw-dot]");
    var panels = section.querySelectorAll("[data-hd-hiw-panel]");
    var frameTemplate = section.getAttribute("data-frame-template") || "";
    var colors = ["#004FAA", "#011D30", "#060E14", "#0D4A6B"];
    var accents = ["#FFB92E", "#3EB0FF", "#3EB0FF", "#FFB92E"];
    var frameCount = 133;
    var images = [];
    var ctx = canvas && canvas.getContext ? canvas.getContext("2d") : null;
    var displayFrame = 0;
    var targetFrame = 0;
    var raf = null;

    if (!sticky || !canvas || !ctx || !frameTemplate) return;

    function padFrame(index) {
      return String(index + 1).padStart(4, "0");
    }

    function frameUrl(index) {
      if (frameTemplate.indexOf("__FRAME__") !== -1) {
        return frameTemplate.replace("__FRAME__", padFrame(index));
      }
      return frameTemplate.replace("0001", padFrame(index));
    }

    function resizeCanvas() {
      var rect = canvas.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      canvas.width = Math.max(1, Math.round(rect.width * dpr));
      canvas.height = Math.max(1, Math.round(rect.height * dpr));
      drawFrame(displayFrame);
    }

    function drawFrame(index) {
      var clamped = Math.max(0, Math.min(Math.round(index), frameCount - 1));
      var img = images[clamped];
      if (!img || !img.complete || !img.naturalWidth) return;
      var cw = canvas.width;
      var ch = canvas.height;
      var iw = img.naturalWidth;
      var ih = img.naturalHeight;
      var mobile = window.innerWidth <= 860;
      var dpr = window.devicePixelRatio || 1;
      var scale = Math.min(cw / iw, ch / ih) * (mobile ? 1.71 : 1.5);
      var sw = iw * scale;
      var sh = ih * scale;
      var x = (cw - sw) / 2 + (mobile ? 0 : cw * 0.18);
      var y = (ch - sh) / 2 + (mobile ? 150 * dpr : ch * 0.23);
      ctx.clearRect(0, 0, cw, ch);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, x, y, sw, sh);
      canvas.classList.add("is-ready");
    }

    function setStep(step) {
      var index = Math.max(0, Math.min(step, 3));
      sticky.style.setProperty("--hd-hiw-bg", colors[index]);
      sticky.style.setProperty("--hd-hiw-accent", accents[index]);
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle("is-active", i === index);
      });
    }

    function updateTarget() {
      var top = section.getBoundingClientRect().top + window.scrollY;
      var max = Math.max(1, section.offsetHeight - window.innerHeight);
      var progress = Math.max(0, Math.min((window.scrollY - top) / max, 1));
      targetFrame = progress * (frameCount - 1);
      setStep(Math.round(progress * 3));
    }

    function tick() {
      var diff = targetFrame - displayFrame;
      if (Math.abs(diff) > 0.15) {
        displayFrame += diff * 0.22;
        drawFrame(displayFrame);
      } else if (Math.round(displayFrame) !== Math.round(targetFrame)) {
        displayFrame = targetFrame;
        drawFrame(displayFrame);
      }
      raf = window.requestAnimationFrame(tick);
    }

    var framesRequested = false;
    function loadFrames() {
      if (framesRequested) return;
      framesRequested = true;
      for (var i = 0; i < frameCount; i += 1) {
        var img = new Image();
        img.decoding = "async";
        img.src = frameUrl(i);
        if (i === 0) {
          img.onload = function () {
            resizeCanvas();
            drawFrame(0);
          };
        }
        images[i] = img;
      }
    }

    // The 266-frame sequence is ~8 MB; fetch it only once the section is
    // within two viewports instead of on page load.
    if ("IntersectionObserver" in window) {
      var frameObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadFrames();
            frameObserver.disconnect();
          }
        });
      }, { rootMargin: "200% 0px" });
      frameObserver.observe(section);
    } else {
      loadFrames();
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var index = Number(dot.getAttribute("data-hd-hiw-dot") || "0");
        var top = section.getBoundingClientRect().top + window.scrollY;
        var max = Math.max(1, section.offsetHeight - window.innerHeight);
        window.scrollTo({ top: top + (index / 3) * max, behavior: "smooth" });
      });
    });

    resizeCanvas();
    updateTarget();
    window.addEventListener("resize", resizeCanvas);
    window.addEventListener("scroll", updateTarget, { passive: true });
    raf = window.requestAnimationFrame(tick);
  }

  function initVideo(root) {
    root.querySelectorAll("[data-hd-video-play]").forEach(function (button) {
      if (button.dataset.hdVideoReady === "true") return;
      button.dataset.hdVideoReady = "true";
      var video = button.querySelector("[data-hd-video]");
      var hasNativeObserver = "IntersectionObserver" in window;

      function resetVideo() {
        if (!video) return;
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {
          // Some browsers can reject currentTime resets before metadata is ready.
        }
        button.classList.remove("is-playing");
      }

      function playVideo() {
        if (!video) return;
        button.classList.add("is-playing");
        var playback = video.play();
        if (playback && typeof playback.catch === "function") {
          playback.catch(function () {
            button.classList.remove("is-playing");
          });
        }
      }

      button.addEventListener("click", function (event) {
        if (!video || event.target === video) return;
        if (button.classList.contains("is-playing") && !video.paused) {
          resetVideo();
          return;
        }
        playVideo();
      });

      video.addEventListener("ended", resetVideo);
      video.addEventListener("pause", function () {
        if (video.ended) return;
        button.classList.remove("is-playing");
      });

      if (hasNativeObserver) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0.2) return;
            resetVideo();
          });
        }, { threshold: [0, 0.2] });
        observer.observe(button);
      } else {
        window.addEventListener("scroll", function () {
          var rect = button.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) resetVideo();
        }, { passive: true });
      }
    });
  }

  function initFocusGame(root) {
    root.querySelectorAll("[data-hd-focus-game]").forEach(function (scene) {
      if (scene.dataset.hdFocusReady === "true") return;
      scene.dataset.hdFocusReady = "true";
      var start = scene.querySelector("[data-hd-focus-start]");
      var timeEl = scene.querySelector("[data-hd-focus-time]");
      var progressEl = scene.querySelector("[data-hd-focus-progress]");
      var states = scene.querySelectorAll("[data-hd-focus-state]");
      var bg = scene.querySelector(".hd-focus-bg");
      var bgVideo = scene.querySelector("[data-hd-focus-bg-video]");
      var character = scene.querySelector("[data-hd-focus-character]");
      var duration = 30000;
      var raf = null;
      var startedAt = null;
      var characterAnimations = {
        idle: null,
        walk: null
      };

      function syncCharacterAnimation(name) {
        var isRunning = name === "running";
        if (characterAnimations.idle) {
          if (isRunning) {
            characterAnimations.idle.pause();
          } else {
            characterAnimations.idle.play();
          }
        }
        if (characterAnimations.walk) {
          if (isRunning) {
            characterAnimations.walk.play();
          } else {
            characterAnimations.walk.stop();
          }
        }
      }

      function resetBgVideo() {
        if (!bgVideo) return;
        try {
          bgVideo.pause();
          bgVideo.currentTime = 0;
        } catch (error) {}
      }

      function playBgVideo() {
        if (!bgVideo) return;
        try {
          bgVideo.muted = true;
          bgVideo.defaultMuted = true;
          bgVideo.setAttribute("muted", "");
          bgVideo.setAttribute("playsinline", "");
        } catch (error) {}
        try {
          bgVideo.currentTime = 0;
        } catch (error) {}
        try {
          var playPromise = bgVideo.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(function () {});
          }
        } catch (error) {}
      }

      function pauseBgVideo() {
        if (!bgVideo) return;
        try {
          bgVideo.pause();
        } catch (error) {}
      }

      function loadCharacterAnimation() {
        if (!character || !window.lottie) return;
        var idleTarget = character.querySelector('[data-hd-focus-lottie="idle"]');
        var walkTarget = character.querySelector('[data-hd-focus-lottie="walk"]');
        var idlePath = character.getAttribute("data-hd-focus-idle");
        var walkPath = character.getAttribute("data-hd-focus-walk");
        if (!idleTarget || !walkTarget || !idlePath || !walkPath) return;

        var options = {
          renderer: "svg",
          loop: true,
          autoplay: false,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid meet",
            progressiveLoad: true
          }
        };

        try {
          characterAnimations.idle = window.lottie.loadAnimation(Object.assign({}, options, {
            container: idleTarget,
            path: idlePath
          }));
          characterAnimations.walk = window.lottie.loadAnimation(Object.assign({}, options, {
            container: walkTarget,
            path: walkPath
          }));
          character.classList.add("is-lottie-ready");
          syncCharacterAnimation(scene.classList.contains("is-running") ? "running" : "idle");
        } catch (error) {}
      }

      function show(name) {
        states.forEach(function (state) {
          state.hidden = state.getAttribute("data-hd-focus-state") !== name;
        });
        scene.classList.toggle("is-running", name === "running");
        scene.classList.toggle("has-finished-run", name === "complete" || name === "reward");
        if (bg && name === "idle") bg.style.left = "0px";
        if (bg && (name === "complete" || name === "reward")) bg.style.left = "-900px";
        if (name === "running") playBgVideo();
        if (name === "idle") resetBgVideo();
        if (name === "complete" || name === "reward") pauseBgVideo();
        syncCharacterAnimation(name);
      }

      var bgVideoRequested = false;
      function ensureBgVideo() {
        if (!bgVideo || bgVideoRequested) return;
        bgVideoRequested = true;
        try {
          bgVideo.load();
        } catch (error) {}
      }

      if (bgVideo) {
        bgVideo.addEventListener("loadeddata", function () {
          scene.classList.add("has-bg-video");
        }, { once: true });
        bgVideo.addEventListener("error", function () {
          scene.classList.add("has-bg-video-failed");
        }, { once: true });
        // The ambience video is ~3.5 MB. Desktop fetches it when the section
        // approaches; small screens and data-saver users only on game start
        // (the SVG scene shows until then).
        var smallScreen = window.matchMedia && window.matchMedia("(max-width: 760px)").matches;
        var saveData = navigator.connection && navigator.connection.saveData;
        if (!smallScreen && !saveData && "IntersectionObserver" in window) {
          var bgVideoObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                ensureBgVideo();
                bgVideoObserver.disconnect();
              }
            });
          }, { rootMargin: "75% 0px" });
          bgVideoObserver.observe(scene);
        }
      }

      loadCharacterAnimation();
      show("idle");

      function tick() {
        var elapsed = Math.min(Date.now() - startedAt, duration);
        var remaining = Math.ceil((duration - elapsed) / 1000);
        if (timeEl) timeEl.textContent = "0:" + String(remaining).padStart(2, "0");
        if (progressEl) progressEl.style.width = (elapsed / duration) * 100 + "%";
        if (bg) bg.style.left = (-900 * (elapsed / duration)).toFixed(2) + "px";
        if (elapsed < duration) {
          raf = window.requestAnimationFrame(tick);
        } else {
          show("complete");
          window.setTimeout(function () {
            show("reward");
          }, 1800);
        }
      }

      if (start) {
        start.addEventListener("click", function () {
          ensureBgVideo();
          if (raf) window.cancelAnimationFrame(raf);
          scene.classList.remove("is-running");
          scene.classList.remove("has-finished-run");
          if (bg) bg.style.left = "0px";
          void scene.offsetWidth;
          startedAt = Date.now();
          if (timeEl) timeEl.textContent = "0:30";
          if (progressEl) progressEl.style.width = "0%";
          show("running");
          raf = window.requestAnimationFrame(tick);
        });
      }
    });
  }

  function initEmailPopup(root) {
    var popup = root.querySelector("[data-hd-email-popup]");
    var bubble = root.querySelector("[data-hd-email-bubble]");
    if (!popup || popup.dataset.hdEmailReady === "true") return;
    popup.dataset.hdEmailReady = "true";

    var storageKey = popup.getAttribute("data-storage-key") || "hum_email_popup_v2_en";
    var triggerDelay = Number(popup.getAttribute("data-trigger-delay") || "30000");
    var captureEndpoint = popup.getAttribute("data-capture-endpoint") || "";
    var captureKey = popup.getAttribute("data-capture-key") || "";
    var captureSource = popup.getAttribute("data-capture-source") || "welcome_popup";
    var captureLanguage = popup.getAttribute("data-capture-language") || "en";
    var emailErrorText = popup.getAttribute("data-error-email") || "Enter a valid email address.";
    var genericErrorText = popup.getAttribute("data-error-generic") || "Something went wrong. Please try again.";
    var capture = popup.querySelector("[data-hd-email-state='capture']");
    var success = popup.querySelector("[data-hd-email-state='success']");
    var form = popup.querySelector(".hd-email-popup__form");
    var input = popup.querySelector("[data-hd-email-input]");
    var error = popup.querySelector("[data-hd-email-error]");
    var copied = popup.querySelector("[data-hd-email-copied]");
    var copyButton = popup.querySelector("[data-hd-email-copy]");
    var hasSucceeded = false;
    var exitBound = false;

    function getStored() {
      try {
        return window.sessionStorage && window.sessionStorage.getItem(storageKey);
      } catch (error) {
        return null;
      }
    }

    function setStored(value) {
      try {
        if (window.sessionStorage) window.sessionStorage.setItem(storageKey, value);
      } catch (error) {}
    }

    function openPopup() {
      if (getStored() === "submitted") return;
      popup.hidden = false;
      if (bubble) bubble.hidden = true;
      if (input && !hasSucceeded) window.setTimeout(function () { input.focus(); }, 80);
    }

    function closePopup() {
      popup.hidden = true;
      if (hasSucceeded) {
        setStored("submitted");
        if (bubble) bubble.hidden = true;
        return;
      }
      setStored("dismissed");
      if (bubble) bubble.hidden = false;
    }

    function showSuccess() {
      hasSucceeded = true;
      setStored("submitted");
      if (capture) capture.hidden = true;
      if (success) success.hidden = false;
      if (error) error.hidden = true;
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function submitToShopify(form) {
      var action = (form.getAttribute("action") || "/contact").split("#")[0];
      var body = new FormData(form);
      return window.fetch(action, {
        method: "POST",
        body: body,
        credentials: "same-origin",
        headers: { Accept: "text/html" }
      });
    }

    function submitLead(email, honeypotValue) {
      if (isPreviewOrigin()) {
        return Promise.resolve({ preview: true });
      }
      if (captureEndpoint && captureKey) {
        return window.fetch(captureEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apikey: captureKey,
            Authorization: "Bearer " + captureKey
          },
          body: JSON.stringify({
            email: email,
            source: captureSource,
            language: captureLanguage,
            _hp_name: honeypotValue || ""
          })
        }).then(function (response) {
          if (!response.ok) throw new Error("Lead capture failed");
          return response;
        });
      }
      return submitToShopify(form).then(function (response) {
        if (!response.ok) throw new Error("Shopify capture failed");
        return response;
      });
    }

    function isPreviewOrigin() {
      return location.hostname === "127.0.0.1" || location.hostname === "localhost" || /\.myshopify\.com$/.test(location.hostname);
    }

    var stored = getStored();
    if (stored === "submitted") {
      return;
    }
    if (stored === "dismissed" && bubble) {
      bubble.hidden = false;
    }

    var timer = window.setTimeout(function () {
      if (!getStored()) openPopup();
    }, triggerDelay);

    document.addEventListener("mouseleave", function (event) {
      if (event.clientY > 0 || exitBound || getStored()) return;
      exitBound = true;
      window.clearTimeout(timer);
      openPopup();
    });

    popup.querySelectorAll("[data-hd-email-dismiss]").forEach(function (button) {
      button.addEventListener("click", closePopup);
    });

    if (bubble) {
      bubble.addEventListener("click", function () {
        if (getStored() === "submitted") return;
        popup.hidden = false;
        bubble.hidden = true;
      });
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var email = input && input.value ? input.value.trim() : "";
        var honeypot = form.querySelector(".hd-email-popup__honeypot");
        var submit = form.querySelector("button[type='submit']");
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError(emailErrorText);
          return;
        }
        if (honeypot && honeypot.value) {
          showSuccess();
          return;
        }
        if (submit) submit.disabled = true;
        if (error) error.hidden = true;
        submitLead(email, honeypot && honeypot.value)
          .then(function () {
            showSuccess();
          })
          .catch(function () {
            if (isPreviewOrigin()) {
              showSuccess();
            } else {
              showError(genericErrorText);
            }
          })
          .finally(function () {
            if (submit) submit.disabled = false;
          });
      });
    }

    if (copyButton) {
      copyButton.addEventListener("click", function () {
        var code = copyButton.getAttribute("data-code") || copyButton.textContent.trim();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(function () {});
        }
        if (copied) {
          copied.hidden = false;
          window.setTimeout(function () { copied.hidden = true; }, 2000);
        }
      });
    }
  }

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    return value.toLocaleString("sl-SI", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2
    });
  }

  function initProduct(root) {
    root.querySelectorAll("[data-hd-product]").forEach(function (productRoot) {
      if (productRoot.dataset.hdProductReady === "true") return;
      productRoot.dataset.hdProductReady = "true";

      var mainImage = productRoot.querySelector(".hd-product-gallery__main img");
      var leadEl = productRoot.querySelector("[data-hd-product-lead]");
      function setMainImageFromThumb(button) {
        if (mainImage && button && button.dataset.full) {
          mainImage.src = button.dataset.full;
          mainImage.srcset = button.dataset.srcset || "";
          mainImage.alt = button.dataset.alt || mainImage.alt || "";
        }
      }

      function updateDescriptionFromButton(button) {
        if (leadEl && leadEl.hasAttribute("data-hd-product-fixed-lead")) return;
        if (leadEl && button && button.dataset.variantDescription) {
          leadEl.textContent = button.dataset.variantDescription;
        }
      }

      productRoot.querySelectorAll("[data-hd-product-thumbs] button").forEach(function (button) {
        button.addEventListener("click", function () {
          productRoot.querySelectorAll("[data-hd-product-thumbs] button").forEach(function (b) { b.classList.remove("is-active"); });
          button.classList.add("is-active");
          setMainImageFromThumb(button);
        });
      });

      var variantInput = productRoot.querySelector("[data-hd-product-variant-id]");
      var quantityInput = productRoot.querySelector("[data-hd-product-quantity]");
      var priceEl = productRoot.querySelector("[data-hd-product-price]");
      var submitLabel = productRoot.querySelector("[data-hd-product-submit-label]");
      var submitButton = productRoot.querySelector(".hd-product-form .hd-btn");
      var stickySubmitButton = productRoot.querySelector("[data-hd-product-mobile-buy] .hd-btn");
      var stickyPriceEl = productRoot.querySelector("[data-hd-product-sticky-price]");
      var form = productRoot.querySelector(".hd-product-form");
      var productForm = productRoot.querySelector("product-form");
      var spinner = productRoot.querySelector(".hd-product-form .loading__spinner");
      var packMixer = productRoot.querySelector("[data-hd-pack-mixer]");
      var packSummary = productRoot.querySelector("[data-hd-pack-summary]");
      var packSlots = Array.prototype.slice.call(productRoot.querySelectorAll("[data-hd-pack-slot]"));
      var unitPrice = Number(priceEl && priceEl.getAttribute("data-unit-price") || 0);
      var activeQty = 1;
      var activeVariantId = variantInput ? String(variantInput.value || "") : "";
      var packSelection = [];

      function sourceValue(source, key) {
        if (!source) return "";
        if (source.dataset) return source.dataset[key] || "";
        return source[key] || "";
      }

      function variantDataFromButton(button) {
        return {
          id: String(button.getAttribute("data-variant-id") || ""),
          price: Number(button.getAttribute("data-variant-price") || 0),
          label: button.getAttribute("data-variant-label") || button.textContent.replace(/\s+/g, " ").trim(),
          variantGallery: button.getAttribute("data-variant-gallery") || "",
          variantImage: button.getAttribute("data-variant-image") || "",
          variantAlt: button.getAttribute("data-variant-alt") || "",
          variantDescription: button.getAttribute("data-variant-description") || ""
        };
      }

      var variantOptions = Array.prototype.slice.call(productRoot.querySelectorAll("[data-hd-product-variants] button"))
        .map(variantDataFromButton)
        .filter(function (option) { return option.id; });

      function getVariantDataById(id) {
        id = String(id || "");
        for (var index = 0; index < variantOptions.length; index += 1) {
          if (variantOptions[index].id === id) return variantOptions[index];
        }
        return null;
      }

      function getVariantButtonById(id) {
        id = String(id || "");
        var buttons = productRoot.querySelectorAll("[data-hd-product-variants] button");
        for (var index = 0; index < buttons.length; index += 1) {
          if (String(buttons[index].getAttribute("data-variant-id") || "") === id) return buttons[index];
        }
        return null;
      }

      if (!activeVariantId && variantOptions[0]) activeVariantId = variantOptions[0].id;

      function discountForQty(qty) {
        if (qty >= 4) return 0.25;
        if (qty >= 2) return 0.15;
        return 0;
      }

      function ensurePackSelection(reset) {
        if (activeQty <= 1) {
          packSelection = [activeVariantId];
          return;
        }
        if (reset || !packSelection.length) {
          packSelection = [];
          for (var resetIndex = 0; resetIndex < activeQty; resetIndex += 1) {
            packSelection.push(activeVariantId);
          }
          return;
        }
        while (packSelection.length < activeQty) packSelection.push(activeVariantId);
        if (packSelection.length > activeQty) packSelection = packSelection.slice(0, activeQty);
        packSelection = packSelection.map(function (id) {
          return getVariantDataById(id) ? id : activeVariantId;
        });
      }

      function subtotalForQty(qty) {
        if (qty === activeQty && activeQty > 1) {
          ensurePackSelection(false);
          return packSelection.reduce(function (total, variantId) {
            var option = getVariantDataById(variantId);
            return total + (option ? option.price : unitPrice);
          }, 0);
        }
        return unitPrice * qty;
      }

      function updatePackMixer() {
        if (!packMixer) return;
        ensurePackSelection(false);
        packMixer.hidden = activeQty <= 1;
        packSlots.forEach(function (slot, slotIndex) {
          slot.hidden = slotIndex >= activeQty;
          slot.querySelectorAll("[data-hd-pack-choice]").forEach(function (choice) {
            choice.classList.toggle("is-active", String(choice.getAttribute("data-variant-id") || "") === String(packSelection[slotIndex] || ""));
          });
        });
        if (!packSummary) return;
        if (activeQty <= 1) {
          packSummary.textContent = "";
          return;
        }
        var counts = {};
        packSelection.forEach(function (variantId) {
          counts[variantId] = (counts[variantId] || 0) + 1;
        });
        packSummary.textContent = Object.keys(counts).map(function (variantId) {
          var option = getVariantDataById(variantId);
          return counts[variantId] + " x " + (option ? option.label : variantId);
        }).join(" · ");
      }

      function updatePrices() {
        productRoot.querySelectorAll("[data-tier-price]").forEach(function (node) {
          var qty = Number(node.getAttribute("data-tier-price") || "1");
          node.textContent = formatMoney(subtotalForQty(qty) * (1 - discountForQty(qty)));
        });
        var activePrice = subtotalForQty(activeQty) * (1 - discountForQty(activeQty));
        if (priceEl) priceEl.textContent = formatMoney(activePrice);
        if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(activePrice);
        if (quantityInput) quantityInput.value = String(activeQty);
        if (variantInput) variantInput.value = activeVariantId;
        if (submitLabel) {
          var singleLabel = submitLabel.getAttribute("data-single") || submitLabel.textContent;
          var multipleLabel = submitLabel.getAttribute("data-multiple") || singleLabel;
          submitLabel.textContent = activeQty > 1 ? multipleLabel.replace("{n}", String(activeQty)) : singleLabel;
        }
        updatePackMixer();
      }

      function updateGalleryFromButton(button) {
        var galleryKey = sourceValue(button, "variantGallery");
        var firstVisibleThumb = null;
        var requestedThumb = null;
        var variantImage = sourceValue(button, "variantImage");

        productRoot.querySelectorAll("[data-hd-product-thumbs] button").forEach(function (thumb) {
          var belongsToGallery = !galleryKey || thumb.dataset.galleryKey === galleryKey;
          thumb.hidden = !belongsToGallery;
          thumb.classList.remove("is-active");
          if (!belongsToGallery) return;
          if (!firstVisibleThumb) firstVisibleThumb = thumb;
          if (variantImage && thumb.dataset.full === variantImage) requestedThumb = thumb;
        });

        var activeThumb = requestedThumb || firstVisibleThumb;
        if (activeThumb) {
          activeThumb.classList.add("is-active");
          setMainImageFromThumb(activeThumb);
          return;
        }

        if (!mainImage || !variantImage) return;
        mainImage.src = variantImage;
        mainImage.srcset = sourceValue(button, "variantSrcset");
        mainImage.alt = sourceValue(button, "variantAlt") || mainImage.alt || "";
      }

      productRoot.querySelectorAll("[data-hd-product-tiers] button").forEach(function (button) {
        button.addEventListener("click", function () {
          activeQty = Number(button.getAttribute("data-qty") || "1");
          productRoot.querySelectorAll("[data-hd-product-tiers] button").forEach(function (b) { b.classList.remove("is-active"); });
          button.classList.add("is-active");
          ensurePackSelection(false);
          updatePrices();
        });
      });

      productRoot.querySelectorAll("[data-hd-product-variants] button").forEach(function (button) {
        var optionPrice = button.querySelector(".hd-product-variant-price");
        var optionUnitPrice = Number(button.getAttribute("data-variant-price") || 0);
        if (optionPrice && optionUnitPrice && !button.disabled) optionPrice.textContent = formatMoney(optionUnitPrice);

        button.addEventListener("click", function () {
          if (button.disabled) return;
          activeVariantId = String(button.getAttribute("data-variant-id") || activeVariantId);
          unitPrice = Number(button.getAttribute("data-variant-price") || unitPrice);
          if (priceEl) priceEl.setAttribute("data-unit-price", String(unitPrice));
          if (variantInput) variantInput.value = button.getAttribute("data-variant-id") || variantInput.value;
          productRoot.querySelectorAll("[data-hd-product-variants] button").forEach(function (b) { b.classList.remove("is-active"); });
          button.classList.add("is-active");
          if (submitButton) submitButton.disabled = false;
          updateDescriptionFromButton(button);
          updateGalleryFromButton(button);
          ensurePackSelection(true);
          updatePrices();
        });
      });

      productRoot.querySelectorAll("[data-hd-pack-choice]").forEach(function (button) {
        button.addEventListener("click", function () {
          if (button.disabled) return;
          var slotIndex = Number(button.getAttribute("data-slot-index") || "0");
          packSelection[slotIndex] = String(button.getAttribute("data-variant-id") || activeVariantId);
          updateDescriptionFromButton(button);
          updateGalleryFromButton(button);
          updatePrices();
        });
      });

      function getPackLineItems() {
        ensurePackSelection(false);
        var counts = {};
        var selectedIds = activeQty > 1 ? packSelection : [activeVariantId];
        selectedIds.forEach(function (variantId) {
          if (!variantId) return;
          counts[variantId] = (counts[variantId] || 0) + 1;
        });
        return Object.keys(counts).map(function (variantId) {
          return {
            id: variantId,
            quantity: counts[variantId]
          };
        });
      }

      function setSubmitting(isSubmitting) {
        if (!submitButton) return;
        if (isSubmitting) {
          submitButton.setAttribute("aria-disabled", "true");
          submitButton.classList.add("loading");
          if (stickySubmitButton) stickySubmitButton.setAttribute("aria-disabled", "true");
          if (spinner) spinner.classList.remove("hidden");
          return;
        }
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("aria-disabled");
        if (stickySubmitButton) stickySubmitButton.removeAttribute("aria-disabled");
        if (spinner) spinner.classList.add("hidden");
      }

      function showSubmitError(message) {
        if (productForm && typeof productForm.handleErrorMessage === "function") {
          productForm.handleErrorMessage(message);
        }
      }

      function bumpCartCount(delta) {
        document.querySelectorAll("#cart-icon-bubble").forEach(function (cartLink) {
          var countEl = cartLink.querySelector(".hd-cart__count");
          if (!countEl) {
            countEl = document.createElement("span");
            countEl.className = "hd-cart__count";
            cartLink.appendChild(countEl);
          }
          var current = Number(countEl.textContent.replace(/\D/g, "") || "0");
          countEl.textContent = String(current + delta);
        });
      }

      function showAddedFallback(delta) {
        bumpCartCount(delta);
        if (!submitLabel) return;
        var addedLabel = submitLabel.getAttribute("data-added") || submitLabel.textContent;
        submitLabel.textContent = addedLabel;
        window.setTimeout(updatePrices, 1800);
      }

      function submitPack(event) {
        if (activeQty <= 1) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (submitButton && submitButton.getAttribute("aria-disabled") === "true") return;

        var cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        var items = getPackLineItems();
        if (!items.length) return;

        setSubmitting(true);
        showSubmitError(false);

        if (cart && typeof cart.setActiveElement === "function") cart.setActiveElement(document.activeElement);

        function addLineItem(item, includeSections) {
          var config = typeof fetchConfig === "function"
            ? fetchConfig("javascript")
            : { method: "POST", headers: { Accept: "application/javascript" } };
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          var formData = new FormData();
          formData.append("id", item.id);
          formData.append("quantity", String(item.quantity));
          formData.append("properties[_humanodoro_pack_size]", String(activeQty));

          if (includeSections && cart && typeof cart.getSectionsToRender === "function") {
            formData.append("sections", cart.getSectionsToRender().map(function (section) { return section.id; }));
            formData.append("sections_url", window.location.pathname);
          }

          config.body = formData;
          return fetch((window.routes && window.routes.cart_add_url) || "/cart/add", config).then(function (response) {
            return response.json();
          });
        }

        items.reduce(function (promise, item, index) {
          return promise.then(function () {
            return addLineItem(item, index === items.length - 1);
          });
        }, Promise.resolve())
          .then(function (response) {
            if (response.status) {
              showSubmitError(response.description || response.message);
              return;
            }

            if (!cart || typeof cart.renderContents !== "function" || !response.sections) {
              showAddedFallback(activeQty);
              return;
            }

            cart.renderContents(response);
          })
          .catch(function (error) {
            console.error(error);
            showSubmitError("Something went wrong. Please try again.");
          })
          .finally(function () {
            setSubmitting(false);
            if (cart && cart.classList && cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
          });
      }

      if (form) form.addEventListener("submit", submitPack, true);

      var activeVariantButton = productRoot.querySelector("[data-hd-product-variants] button.is-active");
      if (activeVariantButton) {
        activeVariantId = String(activeVariantButton.getAttribute("data-variant-id") || activeVariantId);
        unitPrice = Number(activeVariantButton.getAttribute("data-variant-price") || unitPrice);
        updateDescriptionFromButton(activeVariantButton);
        updateGalleryFromButton(activeVariantButton);
      }
      ensurePackSelection(true);
      updatePrices();
    });
  }

  function initQuiz(root) {
    var quizRoot = root.matches("[data-hd-quiz]") ? root : root.querySelector("[data-hd-quiz]");
    if (!quizRoot || quizRoot.dataset.hdQuizReady === "true") return;
    quizRoot.dataset.hdQuizReady = "true";

    var card = quizRoot.querySelector("[data-hd-quiz-card]");
    var dataNode = quizRoot.querySelector("[data-hd-quiz-data]");
    if (!card || !dataNode) return;

    var data = null;
    try {
      data = JSON.parse(dataNode.textContent || "{}");
    } catch (error) {
      return;
    }

    var state = "intro";
    var current = 0;
    var answers = [];
    var emailUnlocked = false;
    var emailValue = "";
    var copy = data.copy || {};
    var questions = data.questions || [];
    var results = data.results || {};
    var images = data.images || {};
    var links = data.links || {};

    function escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function nl2p(text) {
      return String(text || "").split(/\n\n|\\n\\n/).map(function (part) {
        return "<p>" + escapeHtml(part) + "</p>";
      }).join("");
    }

    function scoreAnswers() {
      return answers.reduce(function (total, answerIndex) {
        return total + (3 - Number(answerIndex || 0));
      }, 0);
    }

    function getResultKey() {
      var score = scoreAnswers();
      if (score >= 17) return "scroll-reflex";
      if (score >= 11) return "habit-loop";
      return "mindful-user";
    }

    function resultForKey(key) {
      return results[key] || results["habit-loop"] || {};
    }

    function setCard(html) {
      card.classList.remove("is-transitioning");
      card.innerHTML = html;
      void card.offsetWidth;
      card.classList.add("is-transitioning");
      bindQuizEvents();
    }

    function renderIntro() {
      setCard(
        '<div class="hd-quiz-intro">' +
          '<div class="hd-quiz-character"><img src="' + escapeHtml(images.seeker || "") + '" alt=""></div>' +
          '<p class="hd-quiz-subtitle">' + escapeHtml(copy.introSubtitle || "") + '</p>' +
          '<div class="hd-quiz-narrative"><p>' + escapeHtml(copy.introNarrative || "") + '</p></div>' +
          '<button class="hd-btn" type="button" data-hd-quiz-start>' + escapeHtml(copy.startQuiz || "Start") + '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '</div>'
      );
    }

    function renderQuestion() {
      var question = questions[current];
      if (!question) {
        state = "result";
        renderResult();
        return;
      }
      var progress = Math.round(((current + 1) / questions.length) * 100);
      var dots = questions.map(function (_, index) {
        return '<i class="' + (index <= current ? 'is-active' : '') + '"></i>';
      }).join("");
      var options = (question.options || []).map(function (option, index) {
        return '<button class="hd-quiz-option" type="button" data-hd-quiz-answer="' + index + '"><b>' + String.fromCharCode(65 + index) + '</b><span>' + escapeHtml(option) + '</span><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      }).join("");
      setCard(
        '<div class="hd-quiz-question">' +
          '<div class="hd-quiz-progress"><div class="hd-quiz-progress__row"><span>' + escapeHtml(copy.chapterLabel || "Question") + ' ' + (current + 1) + ' ' + escapeHtml(copy.questionOf || "of") + ' ' + questions.length + '</span><div class="hd-quiz-dots">' + dots + '</div></div><div class="hd-quiz-progress__bar"><span style="width:' + progress + '%"></span></div></div>' +
          '<div class="hd-quiz-scene"><p>' + escapeHtml(question.scene || "") + '</p></div>' +
          '<h2>' + escapeHtml(question.question || "") + '</h2>' +
          '<div class="hd-quiz-options">' + options + '</div>' +
        '</div>'
      );
    }

    function renderResult() {
      var key = getResultKey();
      var result = resultForKey(key);
      var image = images[result.image] || images.seeker || "";
      var code = result.code || "FOCUS10";
      var isMindful = key === "mindful-user";
      var primaryHref = isMindful ? (links.app || "/") : (links.shop || "/en-eu/products/humanodoro-pad");
      var primaryLabel = isMindful ? copy.downloadApp : copy.buyPad;
      var secondaryHref = isMindful ? (links.shop || "/en-eu/products/humanodoro-pad") : (links.app || "/");
      var secondaryLabel = isMindful ? copy.buyPad : copy.downloadApp;
      var discountHtml = emailUnlocked
        ? '<div class="hd-quiz-discount"><p>' + escapeHtml(copy.unlockedBy || "") + '</p><div class="hd-quiz-code"><strong>' + escapeHtml(code) + '</strong><button type="button" data-hd-quiz-copy="' + escapeHtml(code) + '" aria-label="' + escapeHtml(copy.copyCode || "Copy") + '">⧉</button></div><p data-hd-quiz-copied hidden>' + escapeHtml(copy.copied || "Copied") + '</p><p>' + escapeHtml(copy.tapToCopy || "") + '</p></div>'
        : '<form class="hd-quiz-discount" data-hd-quiz-email><h3>' + escapeHtml(copy.unlockDiscount || "") + '</h3><p>' + escapeHtml(copy.enterEmail || "") + '</p><div class="hd-quiz-email-row"><input type="email" required autocomplete="email" value="' + escapeHtml(emailValue) + '" placeholder="' + escapeHtml(copy.emailPlaceholder || "") + '"><button class="hd-btn hd-btn--white" type="submit">' + escapeHtml(copy.getCode || "") + '</button></div><p class="hd-quiz-error" data-hd-quiz-error hidden>' + escapeHtml(copy.invalidEmail || "") + '</p><p>' + escapeHtml(copy.noSpam || "") + '</p></form>';

      setCard(
        '<div class="hd-quiz-result">' +
          '<div class="hd-quiz-character"><img src="' + escapeHtml(image) + '" alt=""></div>' +
          '<p class="hd-quiz-result__kicker">' + escapeHtml(copy.questComplete || "") + '</p>' +
          '<h2>' + escapeHtml(result.title || "") + '</h2>' +
          '<p class="hd-quiz-result__journey">' + escapeHtml(copy.journey || "") + '</p>' +
          '<div class="hd-quiz-result-copy"><p>' + escapeHtml(result.narrative || "") + '</p><hr>' + nl2p(result.text || "") + '</div>' +
          discountHtml +
          '<div class="hd-quiz-actions"><a class="hd-btn" href="' + escapeHtml(primaryHref) + '">' + escapeHtml(primaryLabel || "") + '</a><a class="hd-btn hd-btn--outline" href="' + escapeHtml(secondaryHref) + '">' + escapeHtml(secondaryLabel || "") + '</a></div>' +
          '<div class="hd-quiz-share"><p>' + escapeHtml(copy.shareResult || "") + '</p><div><button type="button" data-hd-quiz-share="twitter" style="background:#00111c">X</button><button type="button" data-hd-quiz-share="facebook" style="background:#1877f2">f</button><button type="button" data-hd-quiz-share="whatsapp" style="background:#25d366">wa</button><button type="button" data-hd-quiz-share="linkedin" style="background:#0a66c2">in</button></div></div>' +
          '<button class="hd-quiz-retake" type="button" data-hd-quiz-retake>' + escapeHtml(copy.retakeQuiz || "") + '</button>' +
        '</div>'
      );
    }

    function share(platform) {
      var result = resultForKey(getResultKey());
      var url = window.location.href;
      var text = (copy.shareText || "") + ' "' + (result.title || "") + '"';
      var hrefs = {
        twitter: "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url),
        facebook: "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url) + "&quote=" + encodeURIComponent(text),
        whatsapp: "https://wa.me/?text=" + encodeURIComponent(text + " " + url),
        linkedin: "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(url)
      };
      if (hrefs[platform]) window.open(hrefs[platform], "_blank", "width=600,height=440");
    }

    function bindQuizEvents() {
      var start = card.querySelector("[data-hd-quiz-start]");
      if (start) {
        start.addEventListener("click", function () {
          state = "quiz";
          current = 0;
          answers = [];
          emailUnlocked = false;
          emailValue = "";
          renderQuestion();
        });
      }

      card.querySelectorAll("[data-hd-quiz-answer]").forEach(function (button) {
        button.addEventListener("click", function () {
          answers.push(Number(button.getAttribute("data-hd-quiz-answer") || "0"));
          if (current < questions.length - 1) {
            current += 1;
            renderQuestion();
          } else {
            state = "result";
            renderResult();
          }
        });
      });

      var emailForm = card.querySelector("[data-hd-quiz-email]");
      if (emailForm) {
        emailForm.addEventListener("submit", function (event) {
          event.preventDefault();
          var input = emailForm.querySelector("input[type='email']");
          var error = emailForm.querySelector("[data-hd-quiz-error]");
          emailValue = input ? input.value.trim() : "";
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
            if (error) error.hidden = false;
            return;
          }
          emailUnlocked = true;
          renderResult();
        });
      }

      var copyButton = card.querySelector("[data-hd-quiz-copy]");
      if (copyButton) {
        copyButton.addEventListener("click", function () {
          var code = copyButton.getAttribute("data-hd-quiz-copy") || "";
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).catch(function () {});
          }
          var copied = card.querySelector("[data-hd-quiz-copied]");
          if (copied) {
            copied.hidden = false;
            window.setTimeout(function () { copied.hidden = true; }, 1800);
          }
        });
      }

      card.querySelectorAll("[data-hd-quiz-share]").forEach(function (button) {
        button.addEventListener("click", function () {
          share(button.getAttribute("data-hd-quiz-share"));
        });
      });

      var retake = card.querySelector("[data-hd-quiz-retake]");
      if (retake) {
        retake.addEventListener("click", function () {
          state = "intro";
          current = 0;
          answers = [];
          emailUnlocked = false;
          emailValue = "";
          renderIntro();
        });
      }
    }

    renderIntro();
  }

  function initFocusScoreQuiz(root) {
    var quizRoot = root.matches("[data-hd-focus-score]") ? root : root.querySelector("[data-hd-focus-score]");
    if (!quizRoot || quizRoot.dataset.hdFocusScoreReady === "true") return;
    quizRoot.dataset.hdFocusScoreReady = "true";

    var card = quizRoot.querySelector("[data-hd-focus-score-card]");
    var dataNode = quizRoot.querySelector("[data-hd-focus-score-data]");
    if (!card || !dataNode) return;

    var data = null;
    try {
      data = JSON.parse(dataNode.textContent || "{}");
    } catch (error) {
      return;
    }

    var state = "intro";
    var current = 0;
    var answers = [];
    var nameValue = "";
    var emailValue = "";
    var copy = data.copy || {};
    var questions = data.questions || [];
    var results = data.results || {};
    var images = data.images || {};
    var links = data.links || {};

    function escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function scoreAnswers() {
      var max = Math.max(1, questions.length * 3);
      var total = answers.reduce(function (sum, value) {
        return sum + Number(value || 0);
      }, 0);
      return Math.round((total / max) * 100);
    }

    function categoryForScore(score) {
      if (score <= 25) return "focusBeginner";
      if (score <= 45) return "distractedPerformer";
      if (score <= 65) return "inconsistentFocuser";
      if (score <= 85) return "deepWorkBuilder";
      return "focusMaster";
    }

    function resultForCategory(category) {
      return results[category] || results.inconsistentFocuser || {};
    }

    function setCard(html) {
      card.classList.remove("is-transitioning");
      card.innerHTML = html;
      void card.offsetWidth;
      card.classList.add("is-transitioning");
      bindFocusScoreEvents();
    }

    function renderIntro() {
      setCard(
        '<div class="hd-score-intro">' +
          '<span class="hd-score-badge">✦ ' + escapeHtml(copy.badge || "") + '</span>' +
          '<h1>' + escapeHtml(copy.title || "") + '</h1>' +
          '<p>' + escapeHtml(copy.subtitle || "") + '</p>' +
          '<div class="hd-score-character"><img src="' + escapeHtml(images.seeker || "") + '" alt=""></div>' +
          '<em class="hd-score-hint">' + escapeHtml(copy.introHint || "") + '</em>' +
          '<button class="hd-btn" type="button" data-hd-score-start>' + escapeHtml(copy.startQuiz || "Start") + '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<p class="hd-score-time">' + escapeHtml(copy.timeEstimate || "") + '</p>' +
        '</div>'
      );
    }

    function renderQuestion() {
      var question = questions[current];
      if (!question) {
        state = "lead";
        renderLead();
        return;
      }

      var progress = Math.round(((current + 1) / questions.length) * 100);
      var options = (question.options || []).map(function (option, index) {
        return '<button class="hd-score-option" type="button" data-hd-score-answer="' + Number(option.value || 0) + '"><b>' + String.fromCharCode(65 + index) + '</b><span>' + escapeHtml(option.text || "") + '</span><svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      }).join("");

      setCard(
        '<div class="hd-score-question">' +
          '<div class="hd-score-progress"><div class="hd-score-progress__row"><span>' + escapeHtml(copy.questionLabel || "Question") + ' ' + (current + 1) + '/' + questions.length + '</span><span>' + progress + '%</span></div><div class="hd-score-progress__bar"><span style="width:' + progress + '%"></span></div></div>' +
          '<p class="hd-score-category">' + escapeHtml(question.category || "") + '</p>' +
          '<h2>' + escapeHtml(question.question || "") + '</h2>' +
          '<div class="hd-score-options">' + options + '</div>' +
        '</div>'
      );
    }

    function renderLead() {
      setCard(
        '<div class="hd-score-lead">' +
          '<div class="hd-score-lead__icon">✦</div>' +
          '<h2>' + escapeHtml(copy.leadTitle || "") + '</h2>' +
          '<p>' + escapeHtml(copy.leadSubtitle || "") + '</p>' +
          '<form class="hd-score-lead-form" data-hd-score-lead>' +
            '<input type="text" autocomplete="given-name" value="' + escapeHtml(nameValue) + '" placeholder="' + escapeHtml(copy.namePlaceholder || "") + '">' +
            '<input type="email" required autocomplete="email" value="' + escapeHtml(emailValue) + '" placeholder="' + escapeHtml(copy.emailPlaceholder || "") + '">' +
            '<button class="hd-btn" type="submit">' + escapeHtml(copy.getResults || "") + '</button>' +
            '<p class="hd-score-error" data-hd-score-error hidden>' + escapeHtml(copy.invalidEmail || "") + '</p>' +
          '</form>' +
          '<button class="hd-score-skip" type="button" data-hd-score-skip>' + escapeHtml(copy.skipCapture || "") + '</button>' +
          '<p class="hd-score-time">' + escapeHtml(copy.noSpam || "") + '</p>' +
        '</div>'
      );
    }

    function renderResult() {
      var score = scoreAnswers();
      var category = categoryForScore(score);
      var result = resultForCategory(category);
      var shareText = encodeURIComponent("I scored " + score + "/100 on the Focus Score Quiz: " + (result.title || ""));
      var shareUrl = encodeURIComponent(window.location.origin + (links.quiz || window.location.pathname));
      var shareLinks = {
        twitter: "https://twitter.com/intent/tweet?text=" + shareText + "&url=" + shareUrl,
        whatsapp: "https://api.whatsapp.com/send?text=" + shareText + "%20" + shareUrl,
        linkedin: "https://www.linkedin.com/sharing/share-offsite/?url=" + shareUrl
      };

      setCard(
        '<div class="hd-score-result" data-score-category="' + escapeHtml(category) + '">' +
          '<div class="hd-score-result__icon"><img src="' + escapeHtml(images.flame || images.seeker || "") + '" width="48" height="48" alt=""></div>' +
          '<div class="hd-score-result__score"><span>' + escapeHtml(copy.yourScore || "") + '</span><strong>' + score + '</strong><span>' + escapeHtml(copy.outOf100 || "") + '</span></div>' +
          '<div class="hd-score-result__category">' + escapeHtml(result.title || "") + '</div>' +
          '<p>' + escapeHtml(result.summary || "") + '</p>' +
          '<div class="hd-score-insights">' +
            '<article><h3>' + escapeHtml(copy.biggestChallenge || "") + '</h3><p>' + escapeHtml(result.challenge || "") + '</p></article>' +
            '<article><h3>' + escapeHtml(copy.improvementTip || "") + '</h3><p>' + escapeHtml(result.tip || "") + '</p></article>' +
            '<article><h3>' + escapeHtml(copy.recommendation || "") + '</h3><p>' + escapeHtml(result.humanodoroTip || "") + '</p></article>' +
          '</div>' +
          '<div class="hd-score-share"><p>' + escapeHtml(copy.shareResult || "") + '</p><div><a href="' + shareLinks.twitter + '" target="_blank" rel="noopener noreferrer" style="background:#00111c">X</a><a href="' + shareLinks.whatsapp + '" target="_blank" rel="noopener noreferrer" style="background:#25d366">wa</a><a href="' + shareLinks.linkedin + '" target="_blank" rel="noopener noreferrer" style="background:#0a66c2">in</a></div></div>' +
          '<div class="hd-score-cta"><h3>' + escapeHtml(copy.ctaTitle || "") + '</h3><p>' + escapeHtml(copy.ctaSubtitle || "") + '</p><div class="hd-score-actions"><a class="hd-btn" href="' + escapeHtml(links.home || "/") + '">' + escapeHtml(copy.ctaButton1 || "") + '</a><a class="hd-btn hd-btn--outline" href="' + escapeHtml(links.shop || "/en-eu/products/humanodoro-pad") + '">' + escapeHtml(copy.ctaButton2 || "") + '</a></div></div>' +
          '<button class="hd-score-retake" type="button" data-hd-score-retake>' + escapeHtml(copy.retake || "") + '</button>' +
          '<p class="hd-score-disclaimer">' + escapeHtml(copy.disclaimer || "") + '</p>' +
        '</div>'
      );
    }

    function bindFocusScoreEvents() {
      var start = card.querySelector("[data-hd-score-start]");
      if (start) {
        start.addEventListener("click", function () {
          state = "question";
          current = 0;
          answers = [];
          renderQuestion();
        });
      }

      card.querySelectorAll("[data-hd-score-answer]").forEach(function (button) {
        button.addEventListener("click", function () {
          answers.push(Number(button.getAttribute("data-hd-score-answer") || "0"));
          if (current < questions.length - 1) {
            current += 1;
            renderQuestion();
          } else {
            state = "lead";
            renderLead();
          }
        });
      });

      var leadForm = card.querySelector("[data-hd-score-lead]");
      if (leadForm) {
        leadForm.addEventListener("submit", function (event) {
          event.preventDefault();
          var inputs = leadForm.querySelectorAll("input");
          nameValue = inputs[0] ? inputs[0].value.trim() : "";
          emailValue = inputs[1] ? inputs[1].value.trim() : "";
          var error = leadForm.querySelector("[data-hd-score-error]");
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
            if (error) error.hidden = false;
            return;
          }
          state = "result";
          renderResult();
        });
      }

      var skip = card.querySelector("[data-hd-score-skip]");
      if (skip) {
        skip.addEventListener("click", function () {
          state = "result";
          renderResult();
        });
      }

      var retake = card.querySelector("[data-hd-score-retake]");
      if (retake) {
        retake.addEventListener("click", function () {
          state = "intro";
          current = 0;
          answers = [];
          nameValue = "";
          emailValue = "";
          renderIntro();
        });
      }
    }

    renderIntro();
  }

  function initBlog(root) {
    var blog = root.querySelector("[data-hd-blog]");
    if (!blog || blog.dataset.hdBlogReady === "true") return;
    blog.dataset.hdBlogReady = "true";

    var cards = Array.prototype.slice.call(blog.querySelectorAll("[data-hd-blog-card]"));
    var filters = Array.prototype.slice.call(blog.querySelectorAll("[data-hd-blog-filter]"));
    var loadButton = blog.querySelector("[data-hd-blog-load]");
    var remaining = blog.querySelector("[data-hd-blog-remaining]");
    var remainingLabel = blog.getAttribute("data-hd-blog-remaining-label") || "remaining";
    var filter = "all";
    var visibleCount = 9;
    var pageSize = 9;

    function matchingCards() {
      return cards.filter(function (card) {
        return filter === "all" || card.getAttribute("data-category") === filter;
      });
    }

    function update(reset) {
      if (reset) visibleCount = pageSize;
      var matches = matchingCards();
      cards.forEach(function (card) {
        card.hidden = true;
      });
      matches.forEach(function (card, index) {
        card.hidden = index >= visibleCount;
      });

      filters.forEach(function (button) {
        var active = button.getAttribute("data-hd-blog-filter") === filter;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });

      var hiddenCount = Math.max(matches.length - visibleCount, 0);
      if (loadButton) loadButton.hidden = hiddenCount <= 0;
      if (remaining) remaining.textContent = hiddenCount > 0 ? "(" + hiddenCount + " " + remainingLabel + ")" : "";
    }

    filters.forEach(function (button) {
      button.addEventListener("click", function () {
        filter = button.getAttribute("data-hd-blog-filter") || "all";
        update(true);
      });
    });

    if (loadButton) {
      loadButton.addEventListener("click", function () {
        visibleCount += pageSize;
        update(false);
      });
    }

    update(true);
  }

  function initCalculator(root) {
    var calc = root.matches("[data-hd-calculator]") ? root : root.querySelector("[data-hd-calculator]");
    if (!calc || calc.dataset.hdCalcReady === "true") return;
    calc.dataset.hdCalcReady = "true";

    var state = {};
    var submit = calc.querySelector("[data-hd-calc-submit]");
    var reset = calc.querySelector("[data-hd-calc-reset]");
    var results = calc.querySelector("[data-hd-calc-results]");
    var moneyBox = calc.querySelector("[data-hd-calc-money]");
    var workweek = calc.querySelector("[data-hd-workweek]");
    var rateInput = calc.querySelector("[data-hd-calc-rate]");
    var levelsNode = calc.querySelector("[data-hd-calc-levels]");
    var levels = {};

    try {
      levels = levelsNode ? JSON.parse(levelsNode.textContent || "{}") : {};
    } catch (error) {
      levels = {};
    }

    function allAnswered() {
      return state.checks && state.duration && state.days;
    }

    function setText(key, value) {
      var node = calc.querySelector('[data-hd-result="' + key + '"]');
      if (node) node.textContent = value;
    }

    function updateSubmit() {
      if (submit) submit.disabled = !allAnswered();
    }

    calc.querySelectorAll("[data-hd-calc-group]").forEach(function (group) {
      var name = group.getAttribute("data-hd-calc-group");
      group.querySelectorAll("[data-hd-calc-option]").forEach(function (button) {
        button.addEventListener("click", function () {
          state[name] = Number(button.getAttribute("value") || "0");
          group.querySelectorAll("[data-hd-calc-option]").forEach(function (other) {
            other.classList.toggle("is-selected", other === button);
          });
          updateSubmit();
        });
      });
    });

    function calculate() {
      if (!allAnswered()) return;

      var minutesPerDay = state.checks * state.duration;
      var hoursPerWeek = (minutesPerDay * state.days) / 60;
      var hoursPerMonth = hoursPerWeek * 4.33;
      var daysPerYear = (hoursPerWeek * 52) / 24;
      var rate = rateInput && rateInput.value ? Number(rateInput.value) : 0;
      var moneyPerMonth = rate ? hoursPerMonth * rate : 0;
      var moneyPerYear = moneyPerMonth * 12;
      var level = "light";

      if (hoursPerMonth >= 80) level = "emergency";
      else if (hoursPerMonth >= 40) level = "serious";
      else if (hoursPerMonth >= 20) level = "moderate";

      setText("minutesPerDay", String(Math.round(minutesPerDay)));
      setText("hoursPerWeek", hoursPerWeek.toFixed(1));
      setText("hoursPerMonth", String(Math.round(hoursPerMonth)));
      setText("daysPerYear", daysPerYear.toFixed(1));
      setText("moneyPerMonth", Math.round(moneyPerMonth) + " EUR");
      setText("moneyPerYear", Math.round(moneyPerYear) + " EUR");
      setText("booksEquiv", String(Math.max(1, Math.round(hoursPerMonth / 6))));
      setText("workoutsEquiv", String(Math.max(1, Math.round(hoursPerMonth))));
      setText("coffeeEquiv", String(Math.max(1, Math.round(hoursPerMonth / 1.5))));
      setText("eveningsEquiv", String(Math.max(1, Math.round(hoursPerMonth / 3))));

      if (moneyBox) moneyBox.hidden = !rate;
      if (workweek) workweek.hidden = hoursPerMonth < 40;

      var levelCard = calc.querySelector("[data-hd-calc-level]");
      var levelTitle = calc.querySelector("[data-level-title]");
      var levelDesc = calc.querySelector("[data-level-desc]");
      if (levelCard) {
        levelCard.setAttribute("data-level", level);
      }
      if (levelTitle && levels[level]) levelTitle.textContent = levels[level].title || "";
      if (levelDesc && levels[level]) levelDesc.textContent = levels[level].desc || "";

      var shareText = (calc.getAttribute("data-share-copy") || "").replace("{hours}", String(Math.round(hoursPerMonth)));
      var pageUrl = window.location.href;
      var links = {
        twitter: "https://twitter.com/intent/tweet?text=" + encodeURIComponent(shareText) + "&url=" + encodeURIComponent(pageUrl),
        whatsapp: "https://api.whatsapp.com/send?text=" + encodeURIComponent(shareText + " " + pageUrl),
        linkedin: "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(pageUrl)
      };
      calc.querySelectorAll("[data-hd-share]").forEach(function (link) {
        var key = link.getAttribute("data-hd-share");
        if (links[key]) link.href = links[key];
      });

      if (results) {
        results.hidden = false;
        results.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      if (reset) reset.hidden = false;
    }

    if (submit) {
      submit.addEventListener("click", calculate);
    }

    if (reset) {
      reset.addEventListener("click", function () {
        state = {};
        calc.querySelectorAll("[data-hd-calc-option]").forEach(function (button) {
          button.classList.remove("is-selected");
        });
        if (results) results.hidden = true;
        reset.hidden = true;
        updateSubmit();
      });
    }

    updateSubmit();
  }

  function initEnterprise(root) {
    var page = root.matches("[data-hd-enterprise]") ? root : root.querySelector("[data-hd-enterprise]");
    if (!page || page.dataset.hdEnterpriseReady === "true") return;
    page.dataset.hdEnterpriseReady = "true";

    var nav = page.querySelector("[data-hd-enterprise-nav]");
    if (!nav) return;

    function updateNav() {
      nav.classList.toggle("ent-nav--scrolled", window.scrollY > 60);
    }

    updateNav();
    window.addEventListener("scroll", updateNav, { passive: true });
  }

  function initAll() {
    document.querySelectorAll("[data-humanodoro-lovable]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.matches("[data-humanodoro-lovable]")) {
      init(event.target);
    }
  });
})();
